import { CapaErrorCode } from '@generated/graphql';
import { ClientProcessActionType } from '@hooks/useProcess';

export interface ProcessEvent extends Event {
  detail: {
    type: ClientProcessActionType;
    payload?: any;
    callback: (errorCode: CapaErrorCode, errorMessage?: string) => void;
  };
}
export interface ProcessEventResult {
  result: CapaErrorCode;
  errorMessage?: string;
}

const dispatchProcessEvent = (
  arg: Omit<ProcessEvent['detail'], 'callback'>
) => {
  return new Promise<ProcessEventResult>((resolve, reject) => {
    const newEvent = new CustomEvent('process', {
      detail: {
        ...arg,
        callback: (errorCode: CapaErrorCode, errorMessage?: string) => {
          const result: ProcessEventResult = {
            result: errorCode,
            errorMessage: errorMessage
          };
          const isSuccess = errorCode === CapaErrorCode.Success;

          if (isSuccess) {
            resolve(result);
          } else {
            reject(result);
          }
        }
      }
    });

    window.dispatchEvent(newEvent);
  });
};

export const processEvents = {
  [ClientProcessActionType.계좌번호복사]: async (payload: {
    bankAccount: string;
  }) => {
    return await dispatchProcessEvent({
      type: ClientProcessActionType.계좌번호복사,
      payload
    });
  },
  [ClientProcessActionType.리뷰작성]: async (payload: {
    rfqId: string;
    quotationPartnerId: string;
    organizationName: string;
    projectName: string;
    partnerProfileLogoId: string;
  }) => {
    return await dispatchProcessEvent({
      type: ClientProcessActionType.리뷰작성,
      payload
    });
  },
  [ClientProcessActionType.발주서재발행]: async (payload: {
    chatRoomId: string;
  }) => {
    return await dispatchProcessEvent({
      type: ClientProcessActionType.발주서재발행,
      payload
    });
  },
  [ClientProcessActionType.결제취소]: async (payload: {
    rfqId: string;
    quotationPartnerId: string;
    purchaseOrderId: string;
    requestRefund: {
      amount: number;
      reason: string;
    };
  }) => {
    return await dispatchProcessEvent({
      type: ClientProcessActionType.결제취소,
      payload
    });
  },
  [ClientProcessActionType.환불요청]: async (payload: {
    rfqId: string;
    quotationPartnerId: string;
    purchaseOrderId: string;
    requestRefund: {
      amount: number;
      reason: string;
    };
  }) => {
    return await dispatchProcessEvent({
      type: ClientProcessActionType.환불요청,
      payload
    });
  },
  [ClientProcessActionType.자동구매확정일연장]: async (payload: {
    rfqId: string;
    quotationPartnerId: string;
    purchaseOrderId: string;
    extendReason: string;
  }) => {
    return await dispatchProcessEvent({
      type: ClientProcessActionType.자동구매확정일연장,
      payload
    });
  },
  [ClientProcessActionType.구매확정]: async (payload: {
    rfqId: string;
    quotationPartnerId: string;
    purchaseOrderId: string;
    escrowVerifiedPW: string;
  }) => {
    return await dispatchProcessEvent({
      type: ClientProcessActionType.구매확정,
      payload
    });
  },
  [ClientProcessActionType.채팅으로이동]: async (payload: {
    chatRoomId: string;
  }) => {
    return await dispatchProcessEvent({
      type: ClientProcessActionType.채팅으로이동,
      payload
    });
  }
};
